import {stringWithoutMeteggedLetters} from 'shared/js/commonHebrew'
import {BlankDictionary} from '../store/stateParts'
import conditionalOptions from 'shared/js/conditionalOptions'

export function toUserDictionaryObjForm(wordList, pinnedWordList, negativeWordList) {
  let uDict = JSON.parse(JSON.stringify(BlankDictionary))
  // console.log('JSON.stringify(uDict):')
  // console.log(JSON.stringify(uDict))
  wordList.forEach(dictString => {
    uDict.entryPresent[dictString] = pinnedWordList.includes(dictString) ? 'pinned' : true
    const withoutMeteggedLetters = stringWithoutMeteggedLetters(conditionalOptions.optionObjFromDictString(dictString).displayText)
    if (uDict.lettersMap[withoutMeteggedLetters]) {
      uDict.lettersMap[withoutMeteggedLetters].push(dictString)
    } else uDict.lettersMap[withoutMeteggedLetters] = [dictString]
  })
  negativeWordList.forEach(dictString => {
    uDict.negativeEntryPresent[dictString] = true
    const withoutMeteggedLetters = stringWithoutMeteggedLetters(conditionalOptions.optionObjFromDictString(dictString).displayText)
    if (uDict.negativeLettersMap[withoutMeteggedLetters]) {
      uDict.negativeLettersMap[withoutMeteggedLetters].push(dictString)
    } else uDict.negativeLettersMap[withoutMeteggedLetters] = [dictString]
  })
  return uDict
}
